<template>
    <div class="ap-error-page">
        <div class="ap-error-page-code">
            <img :src="require(`@/assets/icons/${errorCode}.svg`)" :alt="errorCode" />
        </div>
        <div>
            <div class="ap-error-page-message">{{ message }}</div>
            <div class="ap-error-page-desc" v-html="description"></div>
            <div class="ap-error-page-nav">
                <button href="/" type="submit" :title="$t('appError.link')">{{ $t('appError.link') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AppError',
        props: {
            code: Number,
            message: String,
            description: String
        },
        computed: {
            errorCode() { return this.code != 404 ? 501 : this.code },
        }
    }
</script>

<style lang="scss">
    @import '~styles/colors';

    .ap-error-page {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: auto;
        text-align: left;
        color: $main-font-color;
        margin: auto;

        .ap-error-page-code {
            width: auto;
            height: 240px;
            margin: 0 auto;
            text-align: center;
            font-size: 72px;
            letter-spacing: 10px;

            img {
                height: 100%;
            }
        }

        .ap-error-page-message {
            margin-top: 6px;
            font-weight: 700;
            font-size: 25px;
            line-height: 18px;
            text-transform: uppercase;
            letter-spacing: 1px;
        }

        .ap-error-page-desc {
            @include main-font-opacity(0.53);
            margin-top: 29px;
            font-size: 18px;
            line-height: 22px;
        }

        .ap-error-page-nav {
            margin-top: 45px;

            button {
                text-align: center;
                color: white;
                background-color: $main-blue-color;
                border: none transparent;
                border-radius: 2px;
                cursor: pointer;
                clear: both;
                text-decoration: none;
                display: inline-block;
                font-size: 12px;
                line-height: 40px;
                font-weight: 700;
                height: 40px;
                padding: 0 25px 0 55px;
                background-repeat: no-repeat;
                background-size: 18.37px auto;
                background-position: left 25px center;
                background-image: url('~icons/back-white.svg');
                margin: 0px;
                text-transform: uppercase;

                &:hover {
                    background-color: $main-font-color;
                }

                &:disabled {
                    background-color: #9caab9;
                }
            }
        }

        > div:last-of-type {
            margin-left: 85px;
            width: 500px;
        }
    }
</style>